module.exports = __webpack_public_path__ + "static/media/goods6.d57a7e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/goods6.png
// module id = 1198
// module chunks = 0